export const importComponent = descriptor => async (
  importer = module => import(`modules/${module}`)
) => {
  // by default use the common module if none is specified
  const moduleName = descriptor.module || 'common';
  let module;
  try {
    module = await importer(moduleName);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(descriptor, err);
    throw new Error(
      `Component Loader: Failed to load component ${descriptor.componentName} from invalid or missing module ${moduleName}`
    );
  }

  const component = module[descriptor.componentName];
  if (!component) {
    // eslint-disable-next-line no-console
    console.error(descriptor);
    throw new Error(
      `Component Loader: Module ${moduleName} does not contain ${descriptor.componentName}`
    );
  }

  return { default: component };
};
